import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { uuid, TAnyUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import {
    AuthenticatorEnrolmentOffer,
    AuthenticatorStatus,
    TAuthenticatorEnrolmentOfferCodec,
    TAuthenticatorStatusCodec,
} from "../Authenticator";

export const BeginAuthenticatorEnrolmentForm: TFormIOCodec<TEmptyObjectCodec, TAuthenticatorEnrolmentOfferCodec> = formIO(
    EmptyObject,
    AuthenticatorEnrolmentOffer,
);
export type TBeginAuthenticatorEnrolmentFormCodec = typeof BeginAuthenticatorEnrolmentForm;
export type TBeginAuthenticatorEnrolmentForm = TTypeOfCodec<TBeginAuthenticatorEnrolmentFormCodec>;

const AuthenticatorCode: TRequiredCodec<{code: TAnyStringCodec}> = required({
    code: string(),
});

export const ConfirmAuthenticatorEnrolmentForm: TFormCodec<typeof AuthenticatorCode, TEmptyObjectCodec> = form(
    AuthenticatorCode,
    EmptyObject,
);
export type TConfirmAuthenticatorEnrolmentFormCodec = typeof ConfirmAuthenticatorEnrolmentForm;
export type TConfirmAuthenticatorEnrolmentForm = TTypeOfCodec<TConfirmAuthenticatorEnrolmentFormCodec>;

export const RemoveAuthenticatorForm: TFormCodec<TEmptyObjectCodec, TEmptyObjectCodec> = form(
    EmptyObject,
    EmptyObject,
);
export type TRemoveAuthenticatorFormCodec = typeof RemoveAuthenticatorForm;
export type TRemoveAuthenticatorForm = TTypeOfCodec<TRemoveAuthenticatorFormCodec>;

export const AuthenticatorPageForm: TFormCodec<
    TAuthenticatorStatusCodec,
    TRequiredCodec<{
        begin_enrolment: TBeginAuthenticatorEnrolmentFormCodec;
        confirm_enrolment: TConfirmAuthenticatorEnrolmentFormCodec;
        remove: TRemoveAuthenticatorFormCodec;
    }>
> = form(
    AuthenticatorStatus,
    required({
        begin_enrolment: BeginAuthenticatorEnrolmentForm,
        confirm_enrolment: ConfirmAuthenticatorEnrolmentForm,
        remove: RemoveAuthenticatorForm,
    }),
);
export type TAuthenticatorPageFormCodec = typeof AuthenticatorPageForm;
export type TAuthenticatorPageForm = TTypeOfCodec<TAuthenticatorPageFormCodec>;

const AdminResetUserAuthenticator: TRequiredCodec<{user_id: TAnyUuidCodec}> = required({
    user_id: uuid(),
});

export const AdminResetUserAuthenticatorForm: TFormCodec<typeof AdminResetUserAuthenticator, TEmptyObjectCodec> = form(
    AdminResetUserAuthenticator,
    EmptyObject,
);
export type TAdminResetUserAuthenticatorFormCodec = typeof AdminResetUserAuthenticatorForm;
export type TAdminResetUserAuthenticatorForm = TTypeOfCodec<TAdminResetUserAuthenticatorFormCodec>;
